import React, { useState, Component, useEffect, useContext } from "react";
import { Button } from "@mui/material";
import { ApiCall } from "./../../utility/ApiCalls";
import { toast } from "react-toastify";
import "./../styles/Fields.css";
import Api_Call from "../../ApiCall";
import UserContext from "../Common/UserContext";
export const Guidelines = (props) => {
  //console.log('text from props in Guidelines ', props.text);
  const [guidelinestext, setGuidelinesText] = useState("");

  const { userId } = useContext(UserContext);
  useEffect(() => {
    setGuidelinesText(props.text);
  }, []);

  async function SaveUpdatedNotes(e) {
    console.log(document.getElementById("").innerText);
    console.log(e.target.name, e.target.value);
    if (e.target.value != e.target.defaultValue) {
      const api = new Api_Call();
      const ret = await api.putData(`FAX/UPDATE-FIELD`, {
        userId: userId,
        taskId: sessionStorage.getItem("ActiveTaskID"),
        fieldName: e.target.name,
        newValue: e.target.value,
        op_type: "update",
      });
      toast.success(ret.body);
    }
  }

  if (props.value === "filtered") {
    //console.log('filtered guidelines ', props.text);
    return (
      <div style={{ display: props.display }}>
        {props.taskStatus != 7 ? (
          <textarea
            id={`${props.txtId}`}
            defaultValue={props.text}
            onChange={props.updatedtext}
            // onBlur={props.updateField}
            cols="68"
            rows="10"
          ></textarea>
        ) : (
          <textarea
            id={`${props.txtId}`}
            defaultValue={props.text}
            cols="68"
            rows="10"
            readOnly
          ></textarea>
        )}
      </div>
    );
  } else if (props.value === "clinical") {
    //console.log('clinical summary ', props.text);
    return (
      <div style={{ display: props.display }}>
        {props.taskStatus != 7 ? (
          <textarea
            id={`${props.txtId}`}
            defaultValue={props.text}
            // onBlur={props.updateField}
            onChange={props.updatesummary}
            cols="68"
            rows="11"
          ></textarea>
        ) : (
          <textarea
            id={`${props.txtId}`}
            defaultValue={props.text}
            // onBlur={props.updateField}
            // onChange={props.updatesummary}
            cols="68"
            rows="10"
            readOnly
          ></textarea>
        )}
      </div>
    );
  } else if (props.value === "decision") {
    return (
      <div style={{ display: props.display }}>
        <textarea value={props.text} cols="68" rows="8"></textarea>
      </div>
    );
  } else if (props.value === "IntakeNotes") {
    return (
      <div className="field-container" style={{ display: props.display }}>
        <div className="field-label">
          <label className="">Intake Comments:</label>
        </div>
        <div className="field-text-full">
          <label id={`${props.txtId}`} cols="25" rows="2">
            {" "}
            {props.text}{" "}
          </label>
        </div>
      </div>
    );
  } else if (props.value === "ClinicalNotes") {
    return (
      <div className="field-container" style={{ display: props.display }}>
        <div className="field-label">
          <label className="">Clinical Comments:</label>
        </div>
        <div className="field-text-full">
          <textarea
            id={`${props.txtId}`}
            name={`${props.txtId}`}
            defaultValue={props.text}
            onChange={props.updateClinicalNotes}
            onBlur={props.SaveUpdatedNotes}
            cols="25"
            rows="2"
          ></textarea>
        </div>
      </div>
    );
  } else {
    return (
      <div style={{ display: props.display }}>
        <textarea
          value={props.text}
          //cols="105" rows="460"
          // style={{ width: '100%', height: '800px' }} >
          style={{ width: "100%", height: "800px", fontSize: "14px" }}
        ></textarea>
      </div>
    );
  }
};
